var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-wrapper"},[_c('section',{staticClass:"section"},[_c('h1',{staticClass:"is-size-4 has-text-grey"},[_vm._v("\n      "+_vm._s(_vm.$t('Секунду... Выходим'))+"\n      "),_c('span',{staticClass:"loader auth-wrapper-loader"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }